import { render, staticRenderFns } from "./elasticRouting.vue?vue&type=template&id=661d0b9c"
import script from "./elasticRouting.vue?vue&type=script&lang=js"
export * from "./elasticRouting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports